<template>
  <div class="content">
    <!-- 面包屑 -->
    <!-- <div class="breadcrumb">
      <i class="iconfont icondqwz"></i>
      <ul>
        <li class="active">设备管理</li>
      </ul>
    </div>-->
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 维保单位管理
        </span>
        <div class="w_normalNav" :parent="self">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="GreenSmBtn" @click="addnew">新增</button>
        </div>
        <div class="searchForm1">
          <el-form ref="seefrom" class="uLabelDcontent" :model="seefrom">
            <el-form-item label="单位名称:">
              <el-input placeholder="请输入单位名称" v-model="seefrom.maintCompanyName"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="tableWrapper">
          <el-table
            :data="tableData"
            style="width: 100%"
            class="stripeTable"
            max-height="500px"
            ref="Table"
          >
            <el-table-column
              show-overflow-tooltip
              :label="label"
              :prop="prop"
              :align="align"
              v-for="({prop,label,align}) in config"
              :key="prop.toString()"
            ></el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-link
                  icon="iconfont iconedit"
                  type="text"
                  size="small"
                  @click="edit(scope.$index, scope.row)"
                >编辑</el-link>
                <el-link
                  icon="iconfont icondelete"
                  type="text"
                  size="small"
                  @click="deleteMsg(scope.$index,scope.row)"
                >删除</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination
              layout="prev, pager, next"
              :page-size="10"
              @current-change="handleCurrentChange"
              :total="nTotal"
            ></el-pagination>
          </div>
        </div>
        <el-dialog
          class="editDialog"
          :visible.sync="commandDialog"
          :title="title"
          :close-on-click-modal="false"
        >
          <el-form class="adddevice" ref="base" :model="base" :rules="rules">
            <el-form-item prop="maintCompanyName" label="维保单位名称">
              <el-input placeholder="请输入维保单位名称" v-model.trim="base.maintCompanyName"></el-input>
            </el-form-item>
            <el-form-item prop="businessLicenseNumber" label="营业执照号">
              <el-input placeholder="请输入营业执照号" v-model.trim="base.businessLicenseNumber"></el-input>
            </el-form-item>
            <el-form-item prop="contacts" label="联系人">
              <el-input placeholder="请输入联系人" v-model.trim="base.contacts"></el-input>
            </el-form-item>
            <el-form-item prop="phone" label="联系电话">
              <el-input placeholder="请输入联系电话" v-model.trim="base.phone"></el-input>
            </el-form-item>
            <el-form-item prop="contractStartTime" label="合同开始时间">
              <el-date-picker
                v-model="base.contractStartTime"
                :value-format="valueFormat"
                placeholder="选择时间"
              ></el-date-picker>
            </el-form-item>
            <el-form-item prop="contractEndTime" label="合同结束时间">
              <el-date-picker
                v-model="base.contractEndTime"
                :value-format="valueFormat"
                placeholder="选择时间"
              ></el-date-picker>
            </el-form-item>
            <el-form-item prop="maintScope" label="维保范围">
              <el-input placeholder="请输入维保范围" v-model.trim="base.maintScope"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer" v-if="seeBtn">
            <el-button class="cancelButton" @click="commandDialog = false">取 消</el-button>
            <el-button class="confirmButton" type="primary" @click="submitAdd">确 定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { dt, obj2urlsp } from "utils";

export default {
  data() {
    return {
      rules: {
        maintCompanyName: [
          { required: true, message: "请输入维保单位名称", trigger: "blur" },
        ],
        businessLicenseNumber: [
          { required: true, message: "请输入营业执照号", trigger: "blur" },
        ],
        contacts: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
        ],
        contractStartTime: [
          { required: true, message: "请选择合同开始时间", trigger: "blur" },
        ],
        contractEndTime: [
          { required: true, message: "请选择合同结束时间", trigger: "blur" },
        ],
        maintScope: [
          { required: true, message: "请输入维保范围", trigger: "blur" },
        ]
      },
      key: "",
      title: "",
      tabName: "jsgl",
      showTable: true,
      other: {},
      seeBtn: true,
      commandDialog: false,
      seefrom: {
        maintCompanyName: "",
      },
      base: {
        maintCompanyName: "",
        businessLicenseNumber: "",
        contacts: "",
        phone: "",
        contractStartTime: "",
        contractEndTime: "",
        maintScope: "",
      },
      valueFormat: "yyyy-MM-dd HH:mm:ss",
      tableData: [],
      nTotal: 0,
      currentPage: 1,
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "maintCompanyName",
          label: "维保单位",
        },
        {
          prop: "businessLicenseNumber",
          label: "营业执照号",
        },
        {
          prop: "contacts",
          label: "联系人",
        },
        {
          prop: "phone",
          label: "联系电话",
        },
        {
          prop: "contractStartTime",
          label: "合同开始时间",
        },
        {
          prop: "contractEndTime",
          label: "合同结束时间",
        },
        {
          prop: "maintScope",
          label: "维保范围",
        },
      ];
    },
    dt() {
      return dt.map(({ label }) => label);
    },
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable"),
  },
  methods: {
    //搜索
    subSeefrom() {
      this.getTableData();
    },
    //重置
    reset() {
      this.seefrom.maintCompanyName = "";
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },
    //查询表格数据
    getTableData() {
      this.$axios
        .get(process.env.API_HOST + "operation/maintCompany/selectAll", {
          params: {
            pageSize: 10,
            pageNum: this.currentPage,
            maintCompanyName: this.seefrom.maintCompanyName,
          },
        })
        .then((res) => {
          this.tableData = res.data.list;
          this.nTotal = res.data.total;
        });
    },
    //新增
    addnew() {
      this.seeBtn = true;
      this.title = "新增维保单位";
      if (this.$refs["base"]) this.$refs["base"].clearValidate();
      this.commandDialog = true;
      this.state = 1;
      this.base = {
        maintCompanyName: "",
        businessLicenseNumber: "",
        contacts: "",
        phone: "",
        contractStartTime: "",
        contractEndTime: "",
        maintScope: "",
      };
    },
    //编辑
    edit(index, row) {
      this.title = "修改维保单位";
      this.seeBtn = true;
      if (this.$refs["base"]) this.$refs["base"].clearValidate();
      this.commandDialog = true;
      this.state = 2;
      this.id = row.id;
      this.base.maintCompanyName = row.maintCompanyName;
      this.base.businessLicenseNumber = row.businessLicenseNumber;
      this.base.contacts = row.contacts;
      this.base.phone = row.phone;
      this.base.contractStartTime = row.contractStartTime;
      this.base.contractEndTime = row.contractEndTime;
      this.base.maintScope = row.maintScope;
    },
    //确认
    submitAdd() {
      this.$refs.base.validate((valid) => {
        if (valid) {
          if (this.state === 1) {
            this.$axiospost("operation/maintCompany/insert", {
              maintCompanyName: this.base.maintCompanyName,
              businessLicenseNumber: this.base.businessLicenseNumber,
              contacts: this.base.contacts,
              phone: this.base.phone,
              contractStartTime: this.base.contractStartTime,
              contractEndTime: this.base.contractEndTime,
              maintScope: this.base.maintScope,
            }).then((res) => {
              //console.log(res);
              if (res.data.status === "10000") {
                this.commandDialog = false;
                this.subSeefrom();
                // let loading = Loading.service({});
                // loading.close();
              }
            });
          } else if (this.state === 2) {
            this.$axiospost("operation/maintCompany/update", {
              id: this.id,
              maintCompanyName: this.base.maintCompanyName,
              businessLicenseNumber: this.base.businessLicenseNumber,
              contacts: this.base.contacts,
              phone: this.base.phone,
              contractStartTime: this.base.contractStartTime,
              contractEndTime: this.base.contractEndTime,
              maintScope: this.base.maintScope,
            }).then((res) => {
              //console.log(res);
              if (res.data.status === "10000") {
                this.commandDialog = false;
                this.subSeefrom();
                this.$message({
                  type: "success",
                  message: "修改成功!",
                });
                // let loading = Loading.service({});
                // loading.close();
              }
            });
          }
        }
      });
    },
    //删除
    deleteMsg(index, row) {
      this.$confirm("删除该条数据?", "删除操作", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios
          .delete(
            process.env.API_HOST + "operation/maintCompany/delete",
            {
              params: {
                id: row.id,
              },
            }
          )
          .then((res) => {
            if (res.data.status === "10000") {
              this.subSeefrom();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
          });
      });
    },
  },
  created() {
    this.getTableData();
  },
};
</script>

<style lang="less">
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.el-input__inner:focus {
  border: 1px solid #3587c7;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/upkeep/upkeepCompany.vue